<template>
  <div class="leisure-booking">
    <div class="row reminder-card-area1">
      <div class="col-sm-6">
        <reminder-card
          :booking="upcomingBookings[0]"
          v-if="upcomingBookings && upcomingBookings.length > 0"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-9">
        <h2>Book Leisure Travel</h2>
        <tabs>
          <tab name="Confirmed Booking" :selected="true">
            <family-slider
              @update="switchUpdate"
              :switch="familySwitch"
              v-model="confirmBookingMembers"
              :nominees="familySortByConfirmed"
              :entitlementType="entitlementTypes.confirmed"
            >
              <checkbox
                name="members"
                class="circle"
                :value="usr.uuid"
                v-model="confirmBookingMembers"
                :disabled="
                  getEntitlementRemain(
                    usr.entitlement,
                    entitlementTypes.confirmed
                  ) <= 0
                "
              >
                <b>{{ getFullName(usr) }}</b>
                <div v-if="usr.entitlement">
                  Entitlements Left :{{
                    getEntitlementRemain(
                      usr.entitlement,
                      entitlementTypes.confirmed
                    )
                  }}
                </div>
              </checkbox>
              <hr />
            </family-slider>
            <hr />
            <flight-search-module
              :stations="OD"
              :showStatus="false"
              v-model="confirmedSearchParams"
              :max-date="confirmBookingMaxDate"
              @search="search($event, entitlementTypes.confirmed)"
            >
              <passenger-info
                slot="passenger-info"
                :adults="confirmBookingPassengers.adults"
                :infants="confirmBookingPassengers.infants"
                :children="confirmBookingPassengers.children"
              />
              <!-- @click="search(entitlementTypes.confirmed)" -->
            </flight-search-module>
          </tab>
          <tab name="Standby Booking">
            <div class="margin-bottom x2">
              <label-radio
                name="standby-booking-type"
                label="Booking for staff & Family"
                :value="standbyBookingType.staffAndFamily"
                v-model="currentStandbyBookingType"
              />
              <label-radio
                name="standby-booking-type"
                label="Booking for Friends"
                :value="standbyBookingType.friends"
                v-model="currentStandbyBookingType"
                v-show="selectableBookings.length > 0"
              />
            </div>
            <div
              v-show="
                currentStandbyBookingType === standbyBookingType.staffAndFamily
              "
            >
              <family-slider
                @update="switchUpdate"
                :switch="familySwitch"
                :nominees="familySortByStandby"
                v-model="standbyFamilyBookingMembers"
                :entitlementType="entitlementTypes.standby"
              >
                <checkbox
                  name="members"
                  class="circle"
                  :value="usr.uuid"
                  v-model="standbyFamilyBookingMembers"
                  :disabled="
                    getEntitlementRemain(
                      usr.entitlement,
                      entitlementTypes.standby
                    ) <= 0
                  "
                >
                  <b>{{ getFullName(usr) }}</b>
                </checkbox>
              </family-slider>
              <hr />
              <flight-search-module
                :stations="OD"
                :showStatus="false"
                :max-date="standbyFamilyBookingMaxDate"
                @search="search($event, entitlementTypes.standby)"
                @change="updateSearchParams(entitlementTypes.standby, $event)"
              >
                <passenger-info
                  slot="passenger-info"
                  :adults="standbyFamilyBookingPassengers.adults"
                  :infants="standbyFamilyBookingPassengers.infants"
                  :children="standbyFamilyBookingPassengers.children"
                />
                <!-- @click="search(entitlementTypes.standby) -->
              </flight-search-module>
            </div>
            <div
              v-show="currentStandbyBookingType === standbyBookingType.friends"
            >
              <p>
                <b>Step 1 .</b>
                Select a booking
              </p>
              <horizontal-scroll class="margin-top-x2">
                <booking-card
                  :booking="b"
                  :selectable="true"
                  :key="b.recordLocator"
                  v-for="b in selectableBookings"
                  class="inline-block margin-right-x4"
                  v-show="
                    standbyFriendBookingMaxDate === null ||
                      standbyFriendBookingMaxDate > b.sta
                  "
                >
                  <div class="inline-block" slot="radio-btn">
                    <radio
                      name="parent-booking"
                      :value="b.recordlocator"
                      v-model="selectedPnr"
                    >
                      <div class="inline-block" slot="label">
                        <span>Booking Ref.</span>
                        <b class="blue-font">{{ b.recordlocator }}</b>
                      </div>
                    </radio>
                  </div>
                </booking-card>
              </horizontal-scroll>
              <p>
                <b>Step 2 .</b>
                Select your friends to add to the above booking
              </p>
              <family-slider
                :switch="true"
                option-style
                :showSwitch="false"
                :nominees="friends"
                @update="switchUpdate"
                v-model="standbyFriendBookingMembers"
              ></family-slider>
              <passenger-info
                :adults="standbyFriendBookingPassengers.adults"
                :infants="standbyFriendBookingPassengers.infants"
                :children="standbyFriendBookingPassengers.children"
              />
              <div class="row">
                <ttw-button
                  @click="friendSearch"
                  value="Search"
                  class="col-md-12"
                />
              </div>
            </div>
          </tab>
        </tabs>
      </div>
      <div class="col-md-3">
        <div class="reminder-card-area2">
          <reminder-card
            :booking="upcomingBookings[0]"
            v-if="upcomingBookings && upcomingBookings.length > 0"
          />
        </div>
        <side-bar />
      </div>
    </div>
    <div v-if="upcomingBookings.length > 0" class="row">
      <div class="col-md-12">
        <h2>My Upcoming Leisure Bookings</h2>
        <div class="row upcoming-bookings">
          <booking-card
            :booking="b"
            v-for="b in upcomingBookings"
            :key="b.recordLocator"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import images from "../../core/images";
import config from "../../core/config";
import FamilySlider from "./FamilySlider";
import { toQuery } from "../../core/tools";
import PassengerInfo from "./PassengerInfo";
import LabelRadio from "@/components/base/LabelRadio";
import FlightSearchModule from "@/modules/FlightSearch";
import BookingCard from "@/components/card/BookingCard";
import ReminderCard from "@/components/card/ReminderCard";
import { mapState, mapGetters, mapActions } from "vuex";
import HorizontalScroll from "@/components/layout/HorizontalScroll";
import {
  isChild,
  isAdult,
  isInfant,
  getFullName,
  get30YearDate,
  getSegmentReferences,
} from "../../core/staff-helper";
import {
  tripType,
  tripTypeMap,
  nomineeType,
  marialStatus,
  nomineeStatus,
  entitlementTypes,
  entitlementTypeMap,
  standbyBookingType,
} from "../../core/enum";
export default {
  components: {
    LabelRadio,
    BookingCard,
    ReminderCard,
    FamilySlider,
    PassengerInfo,
    HorizontalScroll,
    FlightSearchModule,
  },
  created() {
    this.getNominees();
    this.getAllBookings();
  },
  data() {
    return {
      members: [],
      images: images,
      selectedPnr: "",
      familySwitch: false,
      standbySearchParams: {},
      confirmedSearchParams: {},
      // members
      confirmBookingMembers: [],
      standbyFamilyBookingMembers: [],
      standbyFriendBookingMembers: [],
      currentStandbyBookingType: standbyBookingType.staffAndFamily,
    };
  },
  methods: {
    getEntitlementRemain(e, type) {
      if (e && type) {
        if (type === entitlementTypes.confirmed) {
          return e.confirmed - e.confirmedUsed;
        } else if (type === entitlementTypes.standby) {
          return e.standby - e.standbyUsed;
        }
      }
      return 0;
    },
    orderByEntitlement(users, type) {
      let amountField =
        type === entitlementTypes.confirmed ? "confirmed" : "standby";
      let usedField =
        type === entitlementTypes.confirmed ? "confirmedUsed" : "standbyUsed";
      let filtered = users.filter(
        (x) => x.nomineeStatus === nomineeStatus.approved
      );
      return filtered.sort((a, b) => {
        let scoreA = a.entitlement[amountField] - a.entitlement[usedField];
        let scoreB = b.entitlement[amountField] - b.entitlement[usedField];
        return scoreB - scoreA;
      });
    },
    getFullName(usr) {
      return getFullName(usr);
    },
    switchUpdate(val) {
      this.familySwitch = val;
    },
    getPaxInfo(val, basePoint) {
      let d = basePoint ? basePoint : new Date();
      let selected = this.nominees.filter((x) => val.indexOf(x.uuid) !== -1);
      if (val.indexOf(this.usr.uuid) !== -1) {
        selected.push(this.usr);
      }
      return {
        adults: selected.filter((x) => isAdult(x.dob, d)),
        infants: selected.filter((x) => isInfant(x.dob, d)),
        children: selected.filter((x) => isChild(x.dob, d)),
      };
    },
    updateSearchParams(type, val) {
      let field =
        type === entitlementTypes.confirmed
          ? "confirmedSearchParams"
          : "standbySearchParams";
      this[field] = val;
    },
    friendSearch() {
      if (!this.selectedPnr) {
        return;
      }
      let current = this.upcomingBookings.find(
        (x) => x.recordlocator === this.selectedPnr
      );
      if (!current) {
        return;
      }
      let searchParams = {
        parentPnr: this.selectedPnr,
        journeyType: tripType.oneWay,
        segments: getSegmentReferences(current),
      };
      let jnys = current.journeys;
      searchParams.journeyType = tripType.oneWay;
      let firstDepDate = moment(jnys[0].departureDate).format("YYYY-MM-DD");
      searchParams.origin1 = jnys[0].origin;
      searchParams.bookingDateEnd = firstDepDate;
      searchParams.bookingDateStart = firstDepDate;
      searchParams.destination1 = jnys[0].destination;
      // mult city / round trip
      if (jnys.length === 2) {
        searchParams.journeyType =
          jnys[0].destination === jnys[1].origin
            ? tripType.roundTrip
            : tripType.multiCity;
        // second departure date
        searchParams.bookingDateEnd = moment(jnys[1].departureDate).format(
          "YYYY-MM-DD"
        );
      }
      if (searchParams.journeyType == tripType.multiCity) {
        searchParams.origin2 = jnys[1].origin;
        searchParams.destination2 = jnys[1].destination;
      }
      this.search(searchParams, entitlementTypes.standby);
    },
    search(searchParams, type) {
      let ids = [];
      let pax = {};
      let maxDate = null;
      if (type === entitlementTypes.confirmed) {
        ids = this.confirmBookingMembers;
        pax = this.confirmBookingPassengers;
        if (this.confirmBookingMaxDate) {
          maxDate = moment(this.confirmBookingMaxDate).format("YYYY-MM-DD");
        }

        let minimalEntitlements = null;
        if (pax) {
          if (pax.adults && pax.adults.length > 0) {
            minimalEntitlements = Math.min(
              ...pax.adults.map((x) =>
                this.getEntitlementRemain(
                  x.entitlement,
                  this.entitlementTypes.confirmed
                )
              )
            );
          }
          if (pax.children && pax.children.length > 0) {
            minimalEntitlements = Math.min(
              ...pax.children.map((x) =>
                this.getEntitlementRemain(
                  x.entitlement,
                  this.entitlementTypes.confirmed
                )
              )
            );
          }
        }
        if (
          Number.isInteger(minimalEntitlements) &&
          searchParams.journeyType !== tripType.oneWay &&
          minimalEntitlements < 2
        ) {
          this.setMessagePopup({
            message: this.$text.insufficientEntitlements,
          });
          return;
        }
      } else {
        // standby family
        if (
          this.currentStandbyBookingType === standbyBookingType.staffAndFamily
        ) {
          ids = this.standbyFamilyBookingMembers;
          pax = this.standbyFamilyBookingPassengers;
          if (this.standbyFamilyBookingMaxDate) {
            maxDate = moment(this.standbyFamilyBookingMaxDate).format(
              "YYYY-MM-DD"
            );
          }
        } else {
          // standby friends
          ids = this.standbyFriendBookingMembers;
          pax = this.standbyFriendBookingPassengers;
          if (this.standbyFriendBookingMaxDate) {
            maxDate = moment(this.standbyFriendBookingMaxDate).format(
              "YYYY-MM-DD"
            );
          }
        }
      }
      let errMsg = "";
      if (ids.length <= 0) {
        errMsg = this.$text.lackOfPax;
      } else if (pax.infants.length > 0 && pax.adults.length === 0) {
        errMsg = this.$text.lackOfAdult;
      }
      if (errMsg) {
        this.setMessagePopup({ message: errMsg });
        return;
      }

      let searchObj = {
        ids: ids,
        maxDate: maxDate,
        token: this.token,
        languageCode: "en",
        adult: pax.adults.length,
        infant: pax.infants.length,
        children: pax.children.length,
        segments: searchParams?.segments,
        parentPnr: searchParams?.parentPnr,
        returnDate: searchParams.bookingDateEnd,
        staffBookingType: entitlementTypeMap[type],
        type: tripTypeMap[searchParams.journeyType],
        departureDate: searchParams.bookingDateStart,
        outbound: `${searchParams.origin1}-${searchParams.destination1}`,
      };

      switch (searchParams.journeyType) {
        case tripType.roundTrip:
          searchObj.inbound = `${searchParams.destination1}-${searchParams.origin1}`;
          break;
        case tripType.multiCity:
          searchObj.inbound = `${searchParams.origin2}-${searchParams.destination2}`;
          break;
      }
      console.log(searchObj);
      let url = `${config.IBE_URL}?${toQuery(searchObj)}`;
      window.open(url, "_blank");
      console.log(url);
    },
    getMaxDate(ids) {
      if (!ids) {
        return null;
      }
      let selected = this.nominees.filter((x) => ids.indexOf(x.uuid) !== -1);
      if (!selected || selected.length === 0) {
        return null;
      }
      let maxDate = null;

      if (
        selected.filter(
          (x) =>
            x.nominee_type == nomineeType.friends ||
            x.nominee_type == nomineeType.travelbuddy
        ).length > 0 ||
        (this.usr.marital == marialStatus.married &&
          selected.filter((x) => x.nominee_type == nomineeType.parents).length >
            0)
      ) {
        maxDate = `${this.financialYear + 1}-04-01`;
      }
      let childrenDOB = selected
        .filter((x) => x.nominee_type == nomineeType.childOfEmployee)
        .map((x) =>
          moment(x.dob)
            .add(30, "years")
            .add(-1, "day")
        );
      const result = moment.min([moment(maxDate), ...childrenDOB]);
      return result.isValid() ? result.format("YYYY-MM-DD") : undefined;
    },
    ...mapActions([
      "setMessagePopup",
      "getAllBookings",
      "getNominees",
      "setFin",
    ]),
  },
  computed: {
    entitlementTypes: () => entitlementTypes,
    standbyBookingType: () => standbyBookingType,
    ...mapState({
      OD: (s) => s.OD,
      token: (s) => s.token,
      usr: (s) => s.userInfo,
      allNominees: (s) => s.nominees,
      nominees: (s) =>
        s.nominees.filter((x) => x.financialYear === s.financialYear),
      financialYear: (s) => s.financialYear,
      confirmBookingMaxDate() {
        let currentY = new Date().getFullYear();
        let d = moment(this.usr?.hiredDate)
          .add(-1, "days")
          .year(currentY);
        if (d.toDate() <= new Date()) {
          d.year(currentY + 1);
        }
        d = moment.min([d, moment().add(21, "days")]);
        const maxDate2 = this.getMaxDate(this.confirmBookingMembers);
        d = maxDate2 && moment(maxDate2).isValid() ? moment.min([d, moment(maxDate2)]) : d;
        return d.isValid() ? d.format("YYYY-MM-DD") : undefined;
      },
      standbyFamilyBookingMaxDate() {
        return this.getMaxDate(this.standbyFamilyBookingMembers);
      },
      standbyFriendBookingMaxDate() {
        let maxDate = this.getMaxDate(this.standbyFriendBookingMembers);
        return maxDate ? new Date(maxDate).getTime() : null;
      },
      standbyFriendBookingPassengers() {
        let d = new Date();
        if (this.selectedPnr) {
          let current = this.selectableBookings.find(
            (x) => x.recorlocator === this.selectedPnr
          );
          if (current) {
            d = current.sta;
          }
        }
        return this.getPaxInfo(this.standbyFriendBookingMembers, d);
      },
      standbyFamilyBookingPassengers() {
        return this.getPaxInfo(
          this.standbyFamilyBookingMembers,
          this.standbySearchParams?.bookingDateEnd
        );
      },
      confirmBookingPassengers() {
        return this.getPaxInfo(
          this.confirmBookingMembers,
          this.confirmedSearchParams?.bookingDateEnd
        );
      },
      friends() {
        return this.orderByEntitlement(
          this.nominees,
          entitlementTypes.standby
        ).filter((x) => x.nominee_type === nomineeType.friends);
      },
      familySortByStandby() {
        let d = get30YearDate(this.standbySearchParams?.bookingDateEnd);
        return this.orderByEntitlement(
          this.nominees,
          entitlementTypes.standby
        ).filter(
          (x) =>
            x.nominee_type !== nomineeType.friends &&
            !(
              x.nominee_type === nomineeType.childOfEmployee &&
              moment(x.dob) < d
            )
        );
      },
      familySortByConfirmed() {
        let d = get30YearDate(this.confirmedSearchParams?.bookingDateEnd);
        var scopeRes = this.orderByEntitlement(
          this.nominees,
          entitlementTypes.confirmed
        ).filter(
          (x) =>
            x.nominee_type !== nomineeType.friends &&
            !(
              x.nominee_type === nomineeType.childOfEmployee &&
              moment(x.dob) < d
            )
        );
        return scopeRes;
      },
    }),
    ...mapGetters(["upcomingBookings", "selectableBookings"]),
  },
};
</script>
<style lang="scss">
.leisure-booking {
  .reminder-card-area1 {
    @media (min-width: 992px) {
      display: none;
    }
  }

  .reminder-card-area2 {
    @media (max-width: 991px) {
      display: none;
    }

    .reminder-card {
      margin-bottom: 2rem;
    }
  }

  .information {
    padding: 1rem;
    margin-bottom: 1rem;
    background-color: #fff;
    border-radius: $border-radius;

    .text-danger {
      font-weight: bold;
      color: rgb(194, 36, 36);
    }
  }

  .nominee-checkbox-outline {
    display: inline-block;
    border-radius: $border-radius;
    border: solid 1px $light-gray;

    &.disabled {
      pointer-events: none;
    }
  }

  hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .passenger-info {
    margin-bottom: 1rem;
  }
}
</style>
